/**
 * Image manipulation utilities for Worthly
 */

/**
 * Create a cropped image from source image and crop parameters
 * @param {string} imageSrc - Base64 or URL of source image
 * @param {object} pixelCrop - Crop parameters { x, y, width, height }
 * @returns {Promise<string>} Base64 data URL of cropped image
 */
export const createCroppedImage = async (imageSrc, pixelCrop) => {
  const image = new window.Image();
  image.src = imageSrc;
  await new Promise((resolve) => { image.onload = resolve; });
  
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );
  
  return canvas.toDataURL('image/jpeg', 0.9);
};
